import React from 'react';
import { Badge } from '@mantine/core';
import type { EntityRegistryEntry, ColumnOptions } from '../types';
import { getSetTransitionWarnings } from '../../validation/setTransitionValidation';

export const setTransitionConfig: EntityRegistryEntry = {
    hideIdInStandard: true,
    fetchAttributes: ['Id', 'DisplayName', 'EntityType', 'Direction', 'TargetSet', 'ActionWorkflow', 'Disabled'],
    listColumns: ({ isStandard }: ColumnOptions) => {
        const columns = [
            {
                key: 'direction',
                label: 'Direction',
                sortable: true,
                render: (entity: any) => {
                    const dir = (entity.Direction || '').toString().trim();
                    if (!dir) return '';
                    const color = dir.toLowerCase() === 'in' ? 'green' : 'orange';
                    return <Badge variant="light" size="sm" color={color}>{dir}</Badge>;
                }
            },
            {
                key: 'targetset',
                label: 'Target Set',
                sortable: true,
                render: (entity: any) => {
                    const val = (entity.TargetSet || '').toString().trim();
                    if (!val) return '';
                    return val.length > 30 ? `${val.slice(0, 27)}...` : val;
                }
            },
            {
                key: 'actionworkflow',
                label: 'Action Workflow',
                sortable: true,
                render: (entity: any) => {
                    const val = (entity.ActionWorkflow || '').toString().trim();
                    if (!val) return '';
                    return val.length > 30 ? `${val.slice(0, 27)}...` : val;
                }
            }
        ];

        if (!isStandard) {
            columns.push({
                key: 'disabled',
                label: 'Status',
                sortable: true,
                render: (entity: any) => {
                    const disabled = entity.Disabled === true || entity.Disabled === 'true' || entity.Disabled === 'True';
                    return <Badge variant="light" size="sm" color={disabled ? 'red' : 'green'}>{disabled ? 'Disabled' : 'Active'}</Badge>;
                }
            });
        }

        return columns;
    },
    getWarnings: (data) => getSetTransitionWarnings(data),
};
